import _ from 'lodash';

class RegisterController {
  /* @ngInject */
  constructor($log, $rootScope, $scope, $filter, $timeout, $location, StorageService, StoreService, LoginService, MerchantDetailStore, MerchantConfigurationService, MerchantDetailService, MerchantDeviceService, StoreStates, FoundationApi, NewTokenService) {
    const that = this;
    const REGISTER_DIALOG_ID = 'register_dialog';
    this.isSuperAdmin = StorageService.getLocalStorage('superAdmin');

    that.filters = {
      search: {
        terms: [],
        text: ''
      }
    };

    that.lista = [];
    that.loading = true;
    that.storeToDelete = undefined;

    that.registerDialog = {
      id: REGISTER_DIALOG_ID,
      title: 'titolo',
      text: '',
      isConfirm: false,
      closeFunc: {},
      confirmFunc: {}
    };

    // FUNZIONE PER APERTURA MODALI
    that.openRegisterDialog = (title, text, isConfirm, closeFunction, confirmFunction) => {
      const conf = isConfirm || false;
      const close = closeFunction || undefined;
      const confirm = confirmFunction || undefined;

      that.registerDialog = {
        id: REGISTER_DIALOG_ID,
        title,
        text,
        isConfirm: conf,
        closeFunc: close,
        confirmFunc: confirm
      };
      setTimeout(() => { FoundationApi.publish(REGISTER_DIALOG_ID, 'open'); }, 300);
    };

    // Servizio che recupera la lista della casse
    that.initStoreList = () => {
      StoreService.getStoreList().then((res) => {
        that.lista = res;
        that.fullLista = res
        that.loading = false;
        $rootScope.$broadcast('STORE_LIST_UPDATE')  
      }); 
    };

    that.initStoreList();

    that.deleteStore = (object) => {
      that.storeToDelete = object;
      that.openRegisterDialog($filter('translate')('store.delete.title'), $filter('translate')('store.delete.text'), true, undefined, that.confimDeleteStore);
    };

    that.confimDeleteStore = () => {
      StoreService.deleteStore(that.storeToDelete.id).then((res) => {
        that.loading = true;
        that.initStoreList();
      }).catch((err) =>{
        console.log(err)
      });
    }

    that.onSearch = () => {
      console.log(that.filters.search.text)
      $timeout(filterShop, 100);
    }

    const filterShop = () => {
      that.lista = $filter('filter')(that.fullLista, that.filters.search.text);
    }

    that.editStore = (object, editMode) => {
      $location.path("/store/storeadd").search({store: object, edit: editMode})
    };

    const deRegRefreshListener = $scope.$on(`MERCHANT_DETAIL_UPDATE`, () => {
      that.loading = true;
      const res = MerchantDetailStore.getMerchantDetail();
      that.lista = res;
      that.checkOnlyTablet();
      that.loading = false;
    });

    $scope.$on(`$destroy`, () => {
      deRegRefreshListener();
    });
  }
}

export default RegisterController;



/** WEBPACK FOOTER **
 ** ./client/app/components/store/register/register.controller.js
 **/